import { render, staticRenderFns } from "./prospeccao.vue?vue&type=template&id=b66bf818"
import script from "./prospeccao.vue?vue&type=script&lang=js"
export * from "./prospeccao.vue?vue&type=script&lang=js"
import style0 from "./prospeccao.vue?vue&type=style&index=0&id=b66bf818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports